import { MAIN_STATE_KEY, MainState } from './main-reducer';

export enum MAIN_ACTION_TYPE {
  SET_MAIN_STATE = 'SET_MAIN_STATE',
  GET_MASTER_DATA = 'GET_MASTER_DATA',
  POST_CONFIRM_ALL_CHANGE = 'POST_CONFIRM_ALL_CHANGE',
  CALL_MASTER_DATA_AND_LANDING_STATUS = 'CALL_MASTER_DATA_AND_LANDING_STATUS',
  CALL_PRELOAD = 'CALL_PRELOAD',
  SET_MAIN_LOADING = 'SET_MAIN_LOADING'
}

export type SetMainStateAction<KeyName extends keyof MainState> = {
  type: MAIN_ACTION_TYPE.SET_MAIN_STATE;
  payload: { key: KeyName, value: MainState[KeyName] };
};

export type GetMasterDataSagaAction = {
  type: MAIN_ACTION_TYPE.GET_MASTER_DATA;
};

export type CallPreloadSagaAction = {
  type: MAIN_ACTION_TYPE.CALL_PRELOAD;
};

export type SetMainLoadingAction = {
  type: MAIN_ACTION_TYPE.SET_MAIN_LOADING;
  payload: { key: string, value: boolean }
};

export type MainActions = SetMainStateAction<MAIN_STATE_KEY> | GetMasterDataSagaAction | CallPreloadSagaAction | SetMainLoadingAction;
